/**
 * Revoq EU Withdrawal Button — theme look inside the app's shadow DOM.
 * The form renders in an open shadow root, so theme CSS cannot reach its
 * fields and buttons. This adds one stylesheet to that root: black-and-white
 * buttons like the rest of the store, dark text in the white inputs and no
 * navy or blue accents.
 */
(function () {
  var CSS = [
    '.widerruf-primary-button {',
    '  font-family: var(--fkx-font-bold, inherit);',
    '  font-weight: 700;',
    '  text-transform: uppercase;',
    '  letter-spacing: 0.06rem;',
    '  transition: box-shadow 100ms ease;',
    '}',
    '.widerruf-primary-button:hover, .widerruf-primary-button:focus {',
    '  background-color: transparent;',
    '  border-color: #ffffff;',
    '}',
    '.widerruf-primary-button:hover {',
    '  box-shadow: 0 0 0 1.3px #ffffff !important;',
    '}',
    '.widerruf-primary-button:focus-visible {',
    '  outline: 2px solid rgba(255, 255, 255, 0.6) !important;',
    '  outline-offset: 3px;',
    '}',
    '.widerruf-button--link { font-family: inherit; }',
    '.widerruf-form__input, textarea, select {',
    '  color: #111111;',
    '  caret-color: #111111;',
    '  border-color: rgba(17, 17, 17, 0.18);',
    '}',
    '.widerruf-form__input::placeholder, textarea::placeholder { color: #7a7a7a; opacity: 1; }',
    '.widerruf-form__input:focus, textarea:focus, select:focus {',
    '  outline: none;',
    '  border-color: #dcdcdc;',
    '  box-shadow: 0 0 0 3px rgba(220, 220, 220, 0.28);',
    '}',
    '.widerruf-form-step-pill {',
    '  border-color: rgba(255, 255, 255, 0.25) !important;',
    '  background: transparent !important;',
    '}',
    '.widerruf-form-step-pill[aria-current="step"] {',
    '  border-color: rgba(255, 255, 255, 0.7) !important;',
    '  background: rgba(255, 255, 255, 0.1) !important;',
    '}',
    '.widerruf-form-branding { border-top-color: rgba(255, 255, 255, 0.18); }',
    '.widerruf-form-branding__link, .widerruf-form-branding__link:hover, .widerruf-form-branding__link:focus {',
    '  color: #ffffff !important;',
    '}',
    'input[type="checkbox"], input[type="radio"] { accent-color: #ffffff; }'
  ].join('\n');

  var sheet = null;
  if ('adoptedStyleSheets' in Document.prototype && 'replaceSync' in CSSStyleSheet.prototype) {
    sheet = new CSSStyleSheet();
    sheet.replaceSync(CSS);
  }

  // Adopted sheets survive the app re-rendering its markup between steps; the <style> tag is the fallback
  function style(root) {
    if (sheet) {
      if (root.adoptedStyleSheets.indexOf(sheet) === -1) root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
      return;
    }
    if (!root.querySelector('style[data-fkx-revoq]')) {
      var tag = document.createElement('style');
      tag.setAttribute('data-fkx-revoq', '');
      tag.textContent = CSS;
      root.appendChild(tag);
    }
  }

  function apply(host) {
    var root = host.shadowRoot;
    if (!root) return;
    style(root);
    if (!sheet && !root.fkxRevoqWatched) {
      root.fkxRevoqWatched = true;
      new MutationObserver(function () { style(root); }).observe(root, { childList: true });
    }
  }

  document.querySelectorAll('.widerruf-form-block').forEach(function (host) {
    apply(host);
    // The app attaches its shadow root after load and then marks the host with data-widerruf-shadow-ready
    new MutationObserver(function () { apply(host); }).observe(host, { attributes: true, attributeFilter: ['data-widerruf-shadow-ready'] });
  });
})();
